var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"}}),_c('circle',{attrs:{"cx":"12","cy":"7","r":"4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }